import { useState } from 'react';
import PropTypes from 'prop-types';
import { LoadingButton } from '@mui/lab';
import { enqueueSnackbar } from 'notistack';
import axios from '../../utils/axios';

RequestQuoteButton.propTypes = {
  params: PropTypes.object,
  setProducts: PropTypes.func,
  facilityId: PropTypes.number
};

export default function RequestQuoteButton({ params, setProducts, facilityId }) {
  const [requestingQuote, setRequestingQuote] = useState(false);

  const requestQuote = (params) => {
    if (params.node.data.requestedQuote) return;
    setRequestingQuote(true);

    axios.post(`orderSheet/requestQuote?facilityId=${facilityId}&productUOMId=${params.data.activeUOM?.id}`)
      .then(() => {
        params.node.data.requestedQuote = true;
        params.node.setData(params.node.data);
        setProducts(products => {
          const product = products.find(product => product.id === params.node.data.id);
          product.requestedQuote = true;
          return products;
        });
        enqueueSnackbar('Request for quote sent', { variant: 'success' })
      })
      .catch(() => enqueueSnackbar('Request quote failed', { variant: 'error' }))
      .finally(() => setRequestingQuote(false)); 
  };

  return (params.node.data.requestedQuote ? "Quote requested" : <LoadingButton loading={requestingQuote} onClick={() => requestQuote(params)}>Request quote</LoadingButton>);
}
